import { IRootState } from '../../../store'
import { IAirwayOptionsState } from '../store/options.types'

export const getAirwayOptionsSelector = (state: IRootState): IAirwayOptionsState => state.options.airwayOptions
